import SelectBar from "../../../map-page/components/select";
import { useContextData } from "../../../map-page/data-context";
import "./index.scss";
interface IProps {
  selectOptions: any
}

const Select = (props: IProps) => {
  const { selectOptions } = props;
  const { contextData: { selectAddress }, setContextData } = useContextData();
  return <div className="web-view-page-select">
    <SelectBar value={selectAddress?.name} style={{ width: "100%" }} selectOptions={selectOptions} onSelect={(data) => {
      setContextData({ selectAddress: data });
    }} />
  </div>
}

export default Select;